/** @jsxImportSource @emotion/react */

import { useLazyQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { FC, useEffect, useState } from 'react'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import {
  findAllStudyNoteGroup,
  findAllStudyNoteGroup_findAllStudyNoteGroup_items as IGroup,
  findAllStudyNoteGroupVariables,
} from '__generatedTypes__/findAllStudyNoteGroup'
import { ClassroomTabEnum } from '__generatedTypes__/globalTypes'
import { FIND_ALL_STUDY_NOTE_GROUP } from 'queries/studyNoteGroup'
import { usePlatformsAndSubjects, Props as UsePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { SubjectTabs } from 'components/SubjectsTabs'
import StudyNoteContent from './StudyNoteContent'
import * as classes from './styles'

const platformsAndSubjectsProps: UsePlatformsAndSubjects = {
  filterSubjects: (subject) => !!subject.classroomTab.find(({ tabEnum }) => tabEnum === ClassroomTabEnum.StudyNotes),
}

const StudyNotes: FC = () => {
  const { subjects, selectedSubject, selectSubject } = usePlatformsAndSubjects(platformsAndSubjectsProps)
  const [groups, setGroups] = useState<IGroup[]>([])

  const [getGroups, { data: groupsData }] = useLazyQuery<findAllStudyNoteGroup, findAllStudyNoteGroupVariables>(
    FIND_ALL_STUDY_NOTE_GROUP
  )

  useEffect(() => {
    selectedSubject &&
      getGroups({
        variables: {
          query: {
            take: TAKE_ALL_ITEMS_COUNT,
            where: {
              subject: {
                id: selectedSubject.id,
              },
            },
          },
        },
      })
  }, [selectedSubject])

  useEffect(() => {
    groupsData && setGroups(groupsData?.findAllStudyNoteGroup.items || [])
  }, [groupsData])

  if (!selectedSubject) {
    return null
  }

  return (
    <div css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Study Notes
      </Typography>
      <SubjectTabs subjects={subjects} selectedSubject={selectedSubject} selectSubject={selectSubject} />
      <StudyNoteContent groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    </div>
  )
}

export default StudyNotes
